import { Button, ColumnDefinition, ComboBox, Icon, Modal, Table, TextInput } from '@abb/common-ux';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Option } from 'react-select';
import { IServiceInstance, IServiceOption, ServiceInstance } from '../../../models';

/* tslint:disable:jsx-no-lambda jsx-no-multiline-js*/
export default class ServerWithServicesTable extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            componentServiceInstances: this.props.componentServiceInstances.map((componentCI: any, idx: number) => {
                return {
                    ...componentCI,
                    counter: idx + 1
                };
            }),
            isModalOpen: false,
            serviceInstanceToDelete: null
        };
    }
    render() {
        const ServerWithServicesTableColumn = ColumnDefinition as new () => ColumnDefinition<any>;
        const deleteButton = (
            <span>
                <Button buttonType='normal' buttonSize='default' onClick={() => {
                    this.setState({
                        isModalOpen: false,
                        serviceInstanceToDelete: null
                    });
                }} >
                    <span aria-hidden='true'>Cancel</span>
                </Button>
                <Button buttonType='primary' buttonSize='default' onClick={() => {
                    this.props.deleteRow(this.state.serviceInstanceToDelete);
                    this.setState({
                        isModalOpen: false,
                        serviceInstanceToDelete: null
                    });
                }} >
                    <span aria-hidden='true'>Confirm</span>
                </Button>
            </span>);

        const serviceInstanceTable = (<Table data={this.state.componentServiceInstances} emptyMessage={this.props.name + ' has no service instances.'}>
                                    <ServerWithServicesTableColumn nowrap={true} cell={(row) => row.counter} header='Instance' />
                                    <ServerWithServicesTableColumn columnWidth={3} nowrap={true} cell={(row) => this.renderService(row)} header='Service' />
                                    <ServerWithServicesTableColumn columnWidth={2} nowrap={true} cell={(row) => this.renderAssetType(row)} header='Asset Type' />
                                    <ServerWithServicesTableColumn nowrap={true} cell={(row) => this.renderAllocateAssets(row, 'Number must be greater than zero and cannot exceed available asset count')} header='Allocate Assets' />
                                    <ServerWithServicesTableColumn nowrap={true} cell={(row) => this.renderManageButtons(row)} header='Manage' />
                                </Table>);

        return (
            <div>
                {serviceInstanceTable}
                <Modal isOpen={this.state.isModalOpen}
                    header='Confirmation'
                    footer={deleteButton}
                    onClose={() => { this.closeModal(); }}
                    modalClassName='styleGuideModal'>
                    Deleting an instance credits available asset count for the service. Please confirm.
                </Modal>
            </div>
        );
    }

    renderService(serviceInstance: IServiceInstance) {
        if (serviceInstance.isBeingEdited) {
            const options = this.props.availableServicesList.map((service: any) => {
                return {
                    value: service.id,
                    label: service.productName
                };
            });
            let value;
            if (serviceInstance.selectedServiceType) {
                value = {
                    value: serviceInstance.selectedServiceType.id,
                    label: serviceInstance.selectedServiceType.productName
                };
            }
            return <ComboBox value={value} onChange={(newOption: Option) => { this.updateServiceValue(newOption, serviceInstance); }} size='small' options={options} />;
        }
        return serviceInstance.selectedServiceType ? serviceInstance.selectedServiceType.productName : '';
    }

    renderAssetType(serviceInstance: IServiceInstance) {
        if (serviceInstance.isBeingEdited) {
            return <TextInput name=''
                labelText=''
                inputSize='small'
                value={serviceInstance.assetType}
                readOnly={true}
                disabled={true}
            />;
        }
        return serviceInstance.assetType;
    }

    renderAllocateAssets(serviceInstance: IServiceInstance, errorMessage: string) {
        if (serviceInstance.isBeingEdited) {
            return <TextInput name='AllocatedAssets'
                labelText=''
                inputSize='small'
                value={serviceInstance.allocatedAssets.value.toString()}
                validationState={serviceInstance.allocatedAssets.valid ? 'valid' : 'invalid'}
                errorMessage={errorMessage}
                onChange={evt => this.updateAllocatedAssetsValue(evt, serviceInstance)}
            />;
        }
        return serviceInstance.allocatedAssets.value.toString();
    }

    renderManageButtons(serviceInstance: IServiceInstance) {
        if (serviceInstance.isBeingEdited) {
            return <div>
                <Button buttonType='normal' buttonSize='minimal' icon='save' disabled={(serviceInstance.selectedServiceType && serviceInstance.selectedServiceType.productName) && serviceInstance.allocatedAssets.valid ? false : true} onClick={() => {
                    this.props.updateServerWithServices(serviceInstance);
                }} />
                <Button buttonType='normal' buttonSize='minimal' icon='close' onClick={() => this.props.cancelEdit()} />
            </div>;
        }
        return <div>
            <Button buttonType='normal' buttonSize='minimal' icon='edit' onClick={() => { this.props.editExistingRow(serviceInstance); }} />
            <Button buttonType='normal' buttonSize='minimal' icon='trash' onClick={() => {
                this.setState({
                    isModalOpen: true,
                    serviceInstanceToDelete: serviceInstance
                });
            }} />
        </div>;
    }

    closeModal() {
        this.setState({
            isModalOpen: false,
            serviceInstanceToDelete: null
        });
    }

    updateAllocatedAssetsValue(evt: any, serviceInstanceEdited: ServiceInstance) {
        this.setState({
            componentServiceInstances: this.state.componentServiceInstances.map((serviceInstance: ServiceInstance) => {
                return Object.assign({}, serviceInstance, { allocatedAssets: serviceInstanceEdited.id === serviceInstance.id ? { value: evt.target.value, valid: this.isValidAllocatedAssets(evt.target.value, serviceInstanceEdited) } : serviceInstance.allocatedAssets });
            })
        });
    }

    isValidAllocatedAssets(value: any, channelInstanceEdited: ServiceInstance) {
        const checkValues = this.props.checkValues(channelInstanceEdited, value);
        return !isNaN(value) && parseInt(value, 10) > 0 && checkValues;
    }

    updateServiceValue(newOption: Option, serviceInstanceEdited: ServiceInstance) {
        const newSelectedServiceType = this.props.availableServicesList.filter((serviceOption: IServiceOption) => serviceOption.id === newOption.value)[0];
        this.setState({
            componentServiceInstances: this.state.componentServiceInstances.map((serviceInstance: ServiceInstance) => {
                return Object.assign({}, serviceInstance, {
                    selectedServiceType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType : serviceInstance.selectedServiceType,
                    assetType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType.assetType.assetTypeName : serviceInstance.assetType,
                    allocatedAssets: {
                        value: serviceInstance.allocatedAssets.value,
                        valid: this.isValidAllocatedAssets(serviceInstance.allocatedAssets.value, Object.assign({}, serviceInstance, {
                            selectedServiceType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType : serviceInstance.selectedServiceType,
                            assetType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType.assetType.assetTypeName : serviceInstance.assetType,
                        }))
                    }
                });
            })
        });
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({
            componentServiceInstances: nextProps.componentServiceInstances.map((componentCI: any, idx: number) => {
                return {
                    ...componentCI,
                    counter: idx + 1
                };
            })
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/SiteLicense/Machines/MachineTable.tsx